import React, { useContext, useEffect, useState } from "react";
import useFetch from "../Hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { classesURL, listSchoolsURL, listTeachersURL } from "../Hooks/URL";
import Classes from "../Templates/Home/Classes/Classes";
import { userContext } from "../Contexts/userContext";

function ClassesPage() {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [searchData, setSearchData] = useState("");
  const [search, setSearch] = useState("");
  const [Filter, setFilter] = useState("");
  const [Open, setOpen] = useState(false);

  const [classes, setClasses] = useState([]);
  const { data, loading, error } = useFetch(
    classesURL,
    page,
    rowsPerPage,
    search,
    null,
    false,
    `&sort=~start_date${Filter}`
  );

  useEffect(() => {
    if (!loading && !error && data) {
      setClasses(data.data);
      setPageCount(data.pagesCount);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "classes", data: "" });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  return (
    <Classes
      role={contextData?.role}
      page={page}
      searchData={searchData}
      search={search}
      setSearchData={setSearchData}
      setSearch={setSearch}
      classes={classes}
      navigate={navigate}
      handleChangePage={handleChangePage}
      Open={Open}
      setOpen={setOpen}
      loading={loading}
      data={data}
      error={error}
      pageCount={pageCount}
      setClasses={setClasses}
      setFilter={setFilter}
    />
  );
}

export default ClassesPage;
